// src/plugins/toast.js
import Vue from 'vue';
import Toast from '../components/toast.vue';

const ToastConstructor = Vue.extend(Toast);

export default {
  install(Vue) {
    // 创建Toast实例
    const toastInstance = new ToastConstructor();

    // 手动挂载实例并添加到DOM中
    toastInstance.$mount(document.createElement('div'));
    document.body.appendChild(toastInstance.$el);

    // 全局定义 $toast 方法
    Vue.prototype.$toast = (message, duration = 3000) => {
      toastInstance.showToast(message, duration);
    };
  }
};



// WEBPACK FOOTER //
// ./src/plugins/toast.js